import actionTypeConstants from "../utils/actionTypeConstants"
function currentPageContextReducer(state = {}, action = {} as any) {
    switch (action.type) {
        case actionTypeConstants.CURRENT_PAGE_CONTEXT:
            return {
                ...state,
                ...action.payload,
            }
        case '':
            return state
        default:
            return state
    }
}

export default currentPageContextReducer